// react
import React from 'react';
import { FormattedMessage } from 'react-intl';

// third-party
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// application
import { loadStripe } from "@stripe/stripe-js";
import api from '../../api/api';
import AsyncAction from '../shared/AsyncAction';
import Currency from '../shared/Currency';
import Indicator from './Indicator';
import { Cart20Svg, Cross10Svg } from '../../svg';
import { cartRemoveItem } from '../../store/cart';
import { url } from '../../services/utils';
import { toast } from 'react-toastify';
import { isRefreshTokenExpired } from '../../services/utils';
import shopApi from '../../api/shop';
import { withRouter } from "react-router-dom";


function IndicatorCart(props) {
    const { cart, cartRemoveItem, history } = props;
    let dropdown;


    const stripePromise = loadStripe(
        process.env.REACT_APP_STRIPE_KEY
    );

    const handleLogout = (refreshToken) => {
        shopApi.logout(refreshToken);
        history.push('/');
        // dispatch(clearWishlist());
    };

    const handlePlaceOrder = async (event) => {
        event.preventDefault();

        const { cart, user } = props;
        const token = user?.refreshToken;
        
        if (isRefreshTokenExpired(token)) {

            toast.error(
                <div>
                    <p>Votre session a expiré. Veuillez vous reconnecter.</p>
                    <button
                        onClick={() => {
                            toast.dismiss(); // Fermer le toast
                            handleLogout(token);
                        }}
                        style={{
                            backgroundColor: "#fff",
                            color: "#d32f2f",
                            border: "1px solid #d32f2f",
                            padding: "5px 10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                            marginTop: "5px"
                        }}
                    >
                        OK
                    </button>
                </div>,
                { theme: "colored", autoClose: false } // Désactiver la fermeture automatique
            );

            return;
        }

        try {
            const response = await api.post("payment/create-checkout-session", {
                firstName: user?.firstName || "Anonymous",
                lastName: user?.lastName || "Anonymous",
                phone: user?.phone,
                email: user?.email,
                user: user?.id,
                items: cart.items.map((item) => ({
                    name: item.product.name,
                    amount: item.price,
                    currency: "cad",
                    quantity: item.quantity,
                    productId: item.product.id || item.product._id,
                })),
            })
            if (response.data.requestedQuantity) {
                toast.error(
                    <div>
                        <p> <FormattedMessage id="shopPageCart.errorQuantity" values={{ product: response.data.productName, quantity: response.data.availableStock }} /></p>
                        <button
                            onClick={() => {
                                toast.dismiss(); // Fermer le toast
                            }}
                            style={{
                                backgroundColor: "#fff",
                                color: "#d32f2f",
                                border: "1px solid #d32f2f",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                                marginTop: "5px"
                            }}
                        >
                            OK
                        </button>
                    </div>,
                    { theme: "colored", autoClose: false } // Désactiver la fermeture automatique
                );

                return;
            };


            const { id: sessionId } = response.data;

            const stripe = await stripePromise;

            const { error } = await stripe.redirectToCheckout({ sessionId });

            if (error) {
                console.error({ errorMessage: error.message });
            }
        } catch (error) {
            console.error({ errorMessage: error.message });
        }
    };


    const items = cart.items.map((item) => {
        let options;
        let image;

        if (item.options) {
            options = (
                <ul className="dropcart__product-options">
                    {item.options.map((option, index) => (
                        <li key={index}>{`${option.optionTitle}: ${option.valueTitle}`}</li>
                    ))}
                </ul>
            );
        }

        if (item.product.images.length) {
            image = (
                <div className="product-image dropcart__product-image">
                    <Link to={url.product(item.product)} className="product-image__body">
                        <img className="product-image__img" src={item.product.images[0]} alt="" />
                    </Link>
                </div>
            );
        }

        const removeButton = (

            <AsyncAction
                action={() => cartRemoveItem(item.product._id || item.product.id)}
                render={({ run, loading }) => {
                    const classes = classNames('dropcart__product-remove btn btn-light btn-sm btn-svg-icon', {
                        'btn-loading': loading,
                    });

                    return (
                        <button type="button" onClick={run} className={classes}>
                            <Cross10Svg />
                        </button>
                    );
                }}
            />
        );

        return (
            <div key={item.id || item._id} className="dropcart__product">
                {image}
                <div className="dropcart__product-info">
                    <div className="dropcart__product-name">
                        <Link to={url.product(item.product)}>{item.product.name}</Link>
                    </div>
                    {options}
                    <div className="dropcart__product-meta">
                        <span className="dropcart__product-quantity">{item.quantity}</span>
                        {' × '}
                        <span className="dropcart__product-price"><Currency value={item.price} /></span>
                    </div>
                </div>
                {removeButton}
            </div>
        );
    });

    if (cart.quantity) {
        dropdown = (
            <div className="dropcart">
                <div className="dropcart__products-list">
                    {items}
                </div>

                <div className="dropcart__totals">
                    <table>
                        <tbody>
                            <tr>
                                <th><FormattedMessage id="Cart.subtotal" defaultMessage="Subtotal" /></th>
                                <td><Currency value={cart.subtotal} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="dropcart__buttons">
                    <Link className="btn btn-secondary" to="/shop/cart"><FormattedMessage id="Cart.viewCart" defaultMessage="View Cart" /></Link>
                    <button onClick={handlePlaceOrder} className="btn btn-primary" ><FormattedMessage id="Cart.checkout" defaultMessage="Checkout" /></button>
                </div>
            </div>
        );
    } else {
        dropdown = (
            <div className="dropcart">
                <div className="dropcart__empty">
                    <FormattedMessage id="Cart.empty" defaultMessage="Your shopping cart is empty!" />
                </div>
            </div>
        );
    }

    return (
        <Indicator url="/shop/cart" dropdown={dropdown} value={cart.quantity} icon={<Cart20Svg />} />
    );
}

const mapStateToProps = (state) => ({
    cart: state.cart,
    user: state.user.userConnected.user
});

const mapDispatchToProps = {
    cartRemoveItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IndicatorCart));
